import { Stack } from "@mui/material";
import { DataSelect } from "../../common/DataSelect/DataSelect";
import { IContextSelectorBarProps } from "../interfaces";

export const ContextSelectorBar = (props: IContextSelectorBarProps) => {
  const { selectors = [], values, onChange } = props;

  return (
    <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
      {selectors.map((selector) => (
        <DataSelect
          key={selector.key}
          label={selector.label}
          value={values[selector.key] ?? null}
          source={selector.source}
          placeholder={selector.placeholder}
          onChange={(nextValue) => {
            onChange(selector.key, nextValue);
          }}
        />
      ))}
    </Stack>
  );
};
